export const STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-800 border-amber-200",
  assigned: "bg-blue-100 text-blue-900 border-blue-200",
  in_progress: "bg-indigo-100 text-indigo-900 border-indigo-200",
  awaiting_inspection: "bg-violet-100 text-violet-900 border-violet-200",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
  closed: "bg-slate-200 text-slate-800 border-slate-300",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  open: "bg-red-100 text-red-800 border-red-200",
  resolved: "bg-emerald-100 text-emerald-800 border-emerald-200",
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  sent: "bg-blue-100 text-blue-900 border-blue-200",
  viewed: "bg-indigo-100 text-indigo-900 border-indigo-200",
  partially_paid: "bg-amber-100 text-amber-800 border-amber-200",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-200",
  overdue: "bg-red-100 text-red-800 border-red-200",
  void: "bg-slate-100 text-slate-400 border-slate-200",
  submitted: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const SEVERITY_STYLES = {
  low: "bg-slate-100 text-slate-700 border-slate-200",
  normal: "bg-slate-100 text-slate-700 border-slate-200",
  medium: "bg-amber-100 text-amber-800 border-amber-200",
  high: "bg-orange-100 text-orange-800 border-orange-200",
  urgent: "bg-red-100 text-red-800 border-red-200",
};

export const CONDITION_STYLES = {
  good: "bg-emerald-100 text-emerald-800 border-emerald-200",
  fair: "bg-amber-100 text-amber-800 border-amber-200",
  poor: "bg-orange-100 text-orange-800 border-orange-200",
  damaged: "bg-red-100 text-red-800 border-red-200",
  missing: "bg-red-100 text-red-800 border-red-200",
  not_checked: "bg-slate-100 text-slate-500 border-slate-200",
};

export const CONDITION_LABELS = {
  excellent: "Excellent",
  good: "Good",
  needs_attention: "Needs Attention",
  critical: "Critical",
};

export const label = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const money = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
